import { Component, ElementRef, ViewChild } from '@angular/core';
import { Platform, NavController, NavParams, AlertController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

import { RichTextEditorPage } from '../rich-text-editor/rich-text-editor';

import { BusinessMessageProvider } from '../../providers/business-message-handler';
import { PushNotificationHandlerProvider } from '../../providers/push-notification-handler';
import { RichTextEditorProvider } from '../../providers/rich-text-editor';

import { Camera, CameraOptions } from '@ionic-native/camera';
import { Geolocation } from '@ionic-native/geolocation';

declare var google: any;
declare var $: any;
declare var Quill: any;

@Component({
  selector: 'page-business-message-manager',
  templateUrl: 'business-message-manager.html',
})
export class BusinessMessageManagerPage {
	@ViewChild('fileInput') fileInput;

	isDom: boolean = false;

	form : FormGroup;
	isLoading: boolean = false;
	saveIsLoading: boolean = false;

	hasImage: boolean = false;	
	imageChanging: boolean = false;

	imageUrl: SafeResourceUrl;	

	hasCoordinates: boolean = false;
	gettingCoordinates: boolean = false;

	hasText: boolean = false;

	map: any;

	quillRte: any;
	rteHasSetup: boolean = false;

	constructor(
		private sanitizer: DomSanitizer,
		public platform: Platform, 
		public richTextEditorProvider: RichTextEditorProvider, 
		public elementRef: ElementRef,
		private geolocation: Geolocation,
		public alertCtrl: AlertController,
		private businessMessageProvider: BusinessMessageProvider,
		private pushNotificationHandlerProvider: PushNotificationHandlerProvider,
		private formBuilder: FormBuilder,
		public navCtrl: NavController, 
		public navParams: NavParams,
		private camera: Camera,
		public actionSheetCtrl: ActionSheetController) {

	    this.form = this.formBuilder.group({
	        "Id": [''],
	        "SentMessage": ['', Validators.compose([Validators.required, Validators.minLength(20)])],
	        "DetailText": [''],

	        "ImagePath": [''],

	        "GeoLat": [''],
	        "GeoLong": [''],	      
	   	}); 

		this.platform.ready().then((readySource) => {
	        if(readySource=="dom"){
	        	this.isDom = true;
	        }
		})	   	
	}

	ionViewDidEnter(){
		if(!this.rteHasSetup){
			this.rteHasSetup = true;
			this.setupRTE();	
		}					
	}	

	setupRTE(){
		//console.log("entered setupRTE")
		let $textArea = $(this.elementRef.nativeElement).find(".wysiwyg");

		var container = $textArea.get(0);
		this.quillRte = new Quill(container, {
		  modules: {
		    toolbar: [
		      [{ header: [1, 2, 3, 4, 5, 6, false] }],
		      [{ 'indent': '-1'}, { 'indent': '+1' }],
		      ['bold', 'italic', 'underline'],	
		      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
		    ]
		  },
		  placeholder: 'Add more detail to your message',
		  theme: 'snow'  // or 'bubble'
		});			

		this.quillRte.on('text-change', (delta, oldDelta, source) => {
		  if (source == 'api') {
		    console.log("An API call triggered this change.");
		  } else if (source == 'user') {
		  	var text = $textArea.find(".ql-editor")[0].innerHTML;

	   		this.form.patchValue(
	   			{"DetailText": text}
	   		);		    
		  }
		});
	}	

	ionViewDidLoad() {
		console.log('ionViewDidLoad BusinessMessageManagerPage');	
	}

	readUrl(event:any) {
	  if (event.target.files && event.target.files[0]) {
	    var reader = new FileReader();

	    this.imageChanging = true;

	    console.log("Entered readUrl");

	    reader.onload = (event:any) => {
	    	console.log("onload");

	    	this.imageChanging = false;

	    	var urlData = event.target.result;

	     	this.imageUrl = event.target.result;

			this.form.patchValue({
		        "ImagePath": event.target.result,				
			})

			console.log("this.form");
			console.log(this.form.value);
	    }

	    console.log("event.target.files[0]");
	    console.log(event.target.files[0]);

	    reader.readAsDataURL(event.target.files[0]);
	  }
	}

	removePicture(){
     	this.imageUrl = null;

     	this.fileInput.nativeElement.value = ""
     	
		this.form.patchValue({
	        "ImagePath": null,				
		})
	}

	getImage (fromCamera): void {
		var sourceType = fromCamera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY

		const options: CameraOptions = {
	  	  	sourceType: sourceType,
		  	destinationType: this.camera.DestinationType.DATA_URL,  
		    mediaType: this.camera.MediaType.PICTURE,    
		    allowEdit: true,
		    quality: 30,
		    targetWidth: 500,
		    targetHeight: 500,
		    encodingType: this.camera.EncodingType.PNG,      
		    correctOrientation: true
		}

		this.imageChanging = true;

		console.log("------------------");
		console.log("About to get image");

		this.camera.getPicture(options).then((dataUrl) => {
			this.imageChanging = false;

	     	this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + dataUrl);

			this.form.patchValue({
		        "ImagePath": 'data:image/png;base64,' + dataUrl,				
			})				    	
		}, (err) => {
			console.log('Unable to take photo');

			this.imageChanging = false;
		});
	}	

	getPicture() {
	    if (Camera['installed']()) {
	      this.presentActionSheet();	   
	    } else {	      
	      this.fileInput.nativeElement.click();	    
	    }
	}

	presentActionSheet() {
	   	let actionSheet = this.actionSheetCtrl.create({
			title: 'Choose the source for an image',
		buttons: [
			{
				text: 'Camera',
				handler: () => {
					this.getImage(true)
				}
			},
			{
				text: 'Image Gallery',
				handler: () => {
					this.getImage(false)
				}
			},
			{
				text: 'Cancel',
				role: 'cancel',
				handler: () => {
					console.log('Cancel clicked');
				}
		    }
	    ]
	   });

	   actionSheet.present();
	}	

	getLocation(){
		if(this.gettingCoordinates == true) return;

		this.removeMap();

		this.gettingCoordinates = true;

		this.geolocation.getCurrentPosition().then((resp) => {
			console.log(resp.coords);

			this.loadGoogleMap({
				latitude: resp.coords.latitude, 
				longitude: resp.coords.longitude		
			})
		}).catch((error) => {
			this.gettingCoordinates = false;

			let alert = this.alertCtrl.create({
				title: 'Geolocation Unavailable',
				subTitle: 'Geolocation is unavailable on this device. Please enable geolocation to provide location for this message.',
				buttons: ['Dismiss']
			});		

			alert.present();							
		});			
	}

	addText(){
		this.hasText=true;
	}

	removeText(){
		this.quillRte.setText("");

		this.hasText=false;

   		this.form.patchValue(
   			{"DetailText":""}
   		);		
	}

	loadGoogleMap(coords){
		$("page-business-message-manager .map-container")
		.append( "<div class='google-map'></div>" )

		this.hasCoordinates = true;		

		setTimeout(()=>{
	        this.map = new google.maps.Map($("page-business-message-manager .google-map")[0], {
	          	center: {lat: coords.latitude, lng: coords.longitude},
	          	zoomControl: false,    
	          	zoom: 14,
				disableDefaultUI: true,	          	
	        });	

	        google.maps.event.trigger(this.map, 'resize');

			var latLong = {lat: coords.latitude, lng: coords.longitude};			

			this.form.patchValue({
		        "GeoLat": coords.latitude,
		        "GeoLong": coords.longitude,	 				
			})
			
	        var marker = new google.maps.Marker({
				position: latLong,
				map: this.map,
				title: "Your location",          
	        });   

	        this.map.setCenter(latLong);

	        this.gettingCoordinates = false
		}, 1000)
	}		

	removeMap(){
		$(".google-map").remove();

		this.map = null;

		this.form.patchValue({
	        "GeoLat": null,
	        "GeoLong": null,	 				
		})

		this.hasCoordinates = false;		
	}

	sendMessage(){
		this.saveIsLoading = true;

		this.businessMessageProvider.createMessage({
			data: this.form.value,
			cb: (resp)=>{
				this.saveIsLoading = false;

				if(resp.Success){
					let alert = this.alertCtrl.create({
						title: 'Message created',
						subTitle: 'Your message was created and sent successfully',
						buttons: ['Dismiss']
					});

					alert.present();						

					console.log("Sending message");

					this.businessMessageProvider.getMessages({
						page: 1, 
						size: 20, 
						cb: ()=>{
							console.log("Message sent!");

							this.businessMessageProvider.getStatus();
						}
					});

					this.form.reset();		

					this.removeText();
					this.removeMap();
					this.removePicture();					
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: resp.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}
			}			
		});		
	}

	createMessage(){
	  let alert = this.alertCtrl.create({
	    title: 'Send message',
	    message: 'Are you sure you want to send this message?',
	    buttons: [
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	        	
	        }
	      },
	      {
	        text: 'Confirm',
	        handler: () => {	
	        	this.sendMessage();
	        }
	      }
	    ]
	  });

	  alert.present();
	}		

}



// WEBPACK FOOTER //
// ./src/pages/business-message-manager/business-message-manager.ts